<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">CONTENTS</p>
<p class="noindent"><a href="#/foreword">Foreword, by Doral Chenoweth Jr.</a></p>
<p class="noindent"><a href="#/ack">Acknowledgements</a></p>
<p class="noindent"><a href="#/intro">Introduction</a></p>
<p class="toc1"><a href="#/chapter1"><b>1. DINERS</b></a></p>
<p class="toc"><a href="#/chapter1#ch1-1">Circus Chef</a></p>
<p class="toc"><a href="#/chapter1#ch1-2">QCB</a></p>
<p class="toc"><a href="#/chapter1#ch1-3">Queen Bee</a></p>
<p class="toc"><a href="#/chapter1#ch1-4">Jack &amp; Benny’s/Benny Klein’s</a></p>
<p class="toc1"><span href="#/chapter2" title="Link target outside of Sample"><b>2. NEIGHBORHOOD HAUNTS</b></span></p>
<p class="toc"><span href="#/chapter2#ch2-1" title="Link target outside of Sample">Maennerchor</span></p>
<p class="toc"><span href="#/chapter2#ch2-2" title="Link target outside of Sample">The Dell</span></p>
<p class="toc"><span href="#/chapter2#ch2-3" title="Link target outside of Sample">Deibel’s</span></p>
<p class="toc"><span href="#/chapter2#ch2-4" title="Link target outside of Sample">Reeb’s</span></p>
<p class="toc"><span href="#/chapter2#ch2-5" title="Link target outside of Sample">Presutti’s</span></p>
<p class="toc"><span href="#/chapter2#ch2-6" title="Link target outside of Sample">Hennick’s</span></p>
<p class="toc"><span href="#/chapter2#ch2-7" title="Link target outside of Sample">The Marble Gang Restaurant</span></p>
<p class="toc"><span href="#/chapter2#ch2-8" title="Link target outside of Sample">Jerry’s Drive-In</span></p>
<p class="toc"><span href="#/chapter2#ch2-9" title="Link target outside of Sample">Engine House No. 5</span></p>
<p class="toc"><span href="#/chapter2#ch2-10" title="Link target outside of Sample">The Place Upstairs</span></p>
<p class="toc"><span href="#/chapter2#ch2-11" title="Link target outside of Sample">Betty’s</span></p>
<p class="toc1"><span href="#/chapter3" title="Link target outside of Sample"><b>3. DOWNTOWN FAVORITES</b></span></p>
<p class="toc"><span href="#/chapter3#ch3-1" title="Link target outside of Sample">The Club at the Hartman Theatre</span></p>
<p class="toc"><span href="#/chapter3#ch3-2" title="Link target outside of Sample">Doersam’s</span></p>
<p class="toc"><span href="#/chapter3#ch3-3" title="Link target outside of Sample">Foerster’s</span></p>
<p class="toc"><span href="#/chapter3#ch3-4" title="Link target outside of Sample">State-Fourth</span></p>
<p class="toc"><span href="#/chapter3#ch3-5" title="Link target outside of Sample">Mills</span></p>
<p class="toc"><span href="#/chapter3#ch3-6" title="Link target outside of Sample">Kuenning’s 19/Kuenning’s Suburban</span></p>
<p class="toc"><span href="#/chapter3#ch3-7" title="Link target outside of Sample">Paoletti’s</span></p>
<p class="toc"><span href="#/chapter3#ch3-8" title="Link target outside of Sample">The Clock</span></p>
<p class="toc"><span href="#/chapter3#ch3-9" title="Link target outside of Sample">Tom Johnson’s</span></p>
<p class="toc"><span href="#/chapter3#ch3-10" title="Link target outside of Sample">Royal Café</span></p>
<p class="toc"><span href="#/chapter3#ch3-11" title="Link target outside of Sample">Patton’s</span></p>
<p class="toc"><span href="#/chapter3#ch3-12" title="Link target outside of Sample">One Nation</span></p>
<p class="toc1"><span href="#/chapter4" title="Link target outside of Sample"><b>4. LAVISH DINING</b></span></p>
<p class="toc"><span href="#/chapter4#ch4-1" title="Link target outside of Sample">Marzetti’s</span></p>
<p class="toc"><span href="#/chapter4#ch4-2" title="Link target outside of Sample">Maramor</span></p>
<p class="toc"><span href="#/chapter4#ch4-3" title="Link target outside of Sample">The Clarmont</span></p>
<p class="toc"><span href="#/chapter4#ch4-4" title="Link target outside of Sample">Jai Lai</span></p>
<p class="toc"><span href="#/chapter4#ch4-5" title="Link target outside of Sample">Tommy Henrich’s</span></p>
<p class="toc"><span href="#/chapter4#ch4-6" title="Link target outside of Sample">L’Armagnac</span></p>
<p class="toc"><span href="#/chapter4#ch4-7" title="Link target outside of Sample">Handke’s</span></p>
<p class="toc"><span href="#/chapter4#ch4-8" title="Link target outside of Sample">Carolyn’s City Park</span></p>
<p class="toc1"><span href="#/chapter5" title="Link target outside of Sample"><b>5. Themed</b></span></p>
<p class="toc"><span href="#/chapter5#ch5-1" title="Link target outside of Sample">Jong Mea</span></p>
<p class="toc"><span href="#/chapter5#ch5-2" title="Link target outside of Sample">Seafood Bay</span></p>
<p class="toc"><span href="#/chapter5#ch5-3" title="Link target outside of Sample">Water Works</span></p>
<p class="toc"><span href="#/chapter5#ch5-4" title="Link target outside of Sample">Terrace Room at the Union</span></p>
<p class="toc"><span href="#/chapter5#ch5-5" title="Link target outside of Sample">David’s on Main/Out on Main/Brownstone on Main</span></p>
<p class="toc1"><span href="#/chapter6" title="Link target outside of Sample"><b>6. Chains</b></span></p>
<p class="toc"><span href="#/chapter6#ch6-1" title="Link target outside of Sample">Green Gables/Burger Boy Food-O-Rama (BBF)</span></p>
<p class="toc"><span href="#/chapter6#ch6-2" title="Link target outside of Sample">G.D. Ritzy’s</span></p>
<p class="toc"><span href="#/chapter6#ch6-3" title="Link target outside of Sample">RAX</span></p>
<p class="toc"><span href="#/chapter6#ch6-4" title="Link target outside of Sample">Damon’s</span></p>
<p class="toc"><span href="#/chapter6#ch6-5" title="Link target outside of Sample">Cantina del Rio</span></p>
<p class="toc"><span href="#/chapter6#ch6-6" title="Link target outside of Sample">The Cooker</span></p>
<p class="toc"><span href="#/chapter6#ch6-7" title="Link target outside of Sample">Fifty-Five Group</span></p>
<p class="noindent1"><span href="#/reci" title="Link target outside of Sample">Recipes</span></p>
<p class="noindent"><span href="#/bib" title="Link target outside of Sample">Bibliography</span></p>
<p class="noindent"><span href="#/author" title="Link target outside of Sample">About the Authors</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?79082658